<template>
    <div>
      <router-view />
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        params: {},
      };
    },
    components: {
      
    },
  };
  </script>
  
  <style></style>
  